import {kngApi, fileApi, talentApi, utilityApi, sspApi, studylogApi, ulcdApi, miscApi} from 'yxt-biz-pc/packages/api';
import { KNG_TYPE } from '../select-kng/src/const';
import axios from 'axios';
const catchTools = async(rq) => {
  let res, error;
  try {
    res = await rq();
  } catch (e) {
    error = e;
  }
  return Promise.resolve([res, error]);
};
// 获取分类树
export const getCatalogTreeData = data => kngApi.post('kngCatalog/tree', data);

export const getImageShowAuthUrl = params => kngApi.get('imgShow/authurl', { params });

export const getImageShowImageUrl = id => kngApi.get(`imgShow/getImageUrl?workId=${id}`);
// 获取相关方信息为不限时候的推荐列表
export const postAssociate = data => kngApi.post('user/associate', data);
// 获取自定义属性配置
export const getCustomAttrConfig = params => kngApi.get('attribute/kng/info', {params});
// 获取混部署信息
export const getMixinConfig = () => catchTools(() => fileApi.get(`local/baseConfigById?orgid=${localStorage.orgId || ''}`));
export const getServeGroups = () => catchTools(() => fileApi.get(`local/serviceGroupUploadConfigByOrgid?orgid=${localStorage.orgId || ''}`));
// 获取服务器组的主服务器
export const getMainServerList = groupId => fileApi.get(`local/serviceConfigById?orgid=${window.getLocalStorage('orgId')}&groupId=${groupId}`);
// 根据服务器组的id,获取上传域名
export const getSecretEndpointById = groupId => fileApi.get(`local/uploadConfig?orgid=${window.getLocalStorage('orgId')}&groupName=${groupId}`);
// 获取高清配置
export const getDefinitionConfig = () => kngApi.get('kv/kng/fileDefinition/conf');
// 获取能力标签开关状态
export const getSkillTagOpenStatus = () => talentApi.get('client/orgsettingi18n/orgparams');
// 获取水印配置
export const getWatermarkConfig = () => fileApi.get('watermark/config');
// 按次购买是够开启
export const getBuyCourseEditState = () => kngApi.post('kv/conf/query/switch', {group: 'COURSE_EDIT_CROUP', key: 'COURSE_EDIT_SWITCH', orgId: window.localStorage.orgId});
// 机构级的倍速设置
export const getMultiConfig = () => kngApi.get('kv/multiple/conf');
// 机构级人脸识别
export const getFaceConfig = () => kngApi.get('face/recognition/org/config');
// 获取播放信息
export const getPlayInfo = data => kngApi.post('study/kngPlay', data);

// 获取知识详情
export const getKngDetail = params => catchTools(() => kngApi.get('upload/edit/info', {params}));
export const getKngDetailOfVisitor = kngId => kngApi.get(`visitor/kng/config/${kngId}`);
export const getContentTags = (kngId, isGroup = false) => isGroup ? utilityApi.get(`tagtargets/${kngId}/grouptags`) : utilityApi.get(`tagtargets/${kngId}/orgtags`);
export const getSkillTags = kngId => kngApi.get(`kngSkillTagMap/${kngId}`);
// 创建课件 ｜ 课程
export const createKng = data => {
  let api = 'upload/create';
  if (data.type === KNG_TYPE.WEIKE) {
    api = 'upload/createWeiKe';
  }
  return catchTools(() => kngApi.post(api, data));
};
// 批量创建课件
export const createKngBatch = data => catchTools(() => kngApi.post('upload/create/batch', data));
// 批量创建微课中心的微课
export const createNewWeiKeBatch = data => catchTools(() => kngApi.post('upload/createWeiKe', data));
// 编辑课件｜课程
export const editKng = data => {
  let api = 'upload/update';
  let methods = 'post';
  if (data.type === KNG_TYPE.COURSE) {
    // 集团版编辑
    if (data.shareFlag === 2) {
      api = 'upload/update/course';
    } else {
      // 课程的基本信息保存
      methods = 'put';
      api = 'kngdraft/infocreate';
    }
  }
  return catchTools(() => kngApi[methods](api, data));
};
// 草稿章节兼容处理
export const ulcdReleaseInfo = courseId => catchTools(() => ulcdApi.get(`/draft/releaseInfo/kng/${courseId}`));
// 保存课程包草稿信息
export const saveCourseDraft = data => catchTools(() => kngApi.put('kngdraft/infocreate', data));
// 保存内容标签
// export const saveContentTags = (kngId, data) => utilityApi.put(`tagtargets/${kngId}/tag`, data);
// 保存能力标签
// export const saveSkillTags = data => kngApi.post('kngSkillTagMap', data);

// 关键点
export const getPointList = kngId => kngApi.get(`/mark/manage/key/point/${kngId}`);
export const addPoints = data => kngApi.post('mark/save/key/point', data);
// AI字幕剩余时长
export const getRestTimeOfAI = () => kngApi.get('file/account/detail');
// 获取自动提炼的关键点
export const getPointOfAI = (kngId, fileId) => kngApi.get(`file/subtitles/topic/${kngId}/${fileId}`);

// 发起本地转码
export const postLocalTranscode = async(endpoint, files) => {
  function pad(number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }
  const callbackUrl = kngApi.defaults.baseURL + 'file/trans/callback';
  files.forEach(f => {
    f.callbackUrl = callbackUrl;
  });
  // 转换时间戳
  const date = new Date();
  let iSOString;
  if (date.toISOString) {
    iSOString = date.toISOString();
  } else {
    iSOString = date.getUTCFullYear() +
        '-' + pad(date.getUTCMonth() + 1) +
        '-' + pad(date.getUTCDate()) +
        'T' + pad(date.getUTCHours()) +
        ':' + pad(date.getUTCMinutes()) +
        ':' + pad(date.getUTCSeconds()) +
        '.' + (date.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        'Z';
  }
  // 先获取身份
  const result = await fileApi.get('token/upload4Front', {
    params: {
      platform: 'local',
      headers: { 'x-bce-date': iSOString.replace(/\.\d+Z$/, 'Z'), 'Content-Length': JSON.stringify(files).length }
    }
  });
  return axios.post(endpoint + '/receive/tsc', files, { headers: { 'x-bce-date': result['x-bce-date'], Authorization: result.signature } })
    .catch((e) => {
      putKngTransError(files.map(item => item.targetId));
      commonLog('006', '私有云转码失败', JSON.stringify(e || {}));
    });
};
// 标记转码失败
export const putKngTransError = data => kngApi.put('upload/kng/status', data);

export const getFileInfoByFileId = fileId => fileApi.get(`fileInfo/detail?id=${fileId}`);

export const getRewardState = () => sspApi.get('point/reward/module/status/MK0001');

export const getUploadLimit = () => fileApi.get(`config/uploadLimit?orgId=${localStorage.orgId || ''}&configKey=KnowledgeConfigKey`);

export const getWeikeUpdateState = fileId => kngApi.get(`/upload/newWeiKe/upgrade/${fileId}`);
export const commonLog = (logTypeCode, ext1 = '', ext2 = '', ext3 = '', ext4 = '')=> {
  try {
    const bodyParams = {
      logTypeCode, // 日志类型编号
      pageUrl: location.href, // 页面地址
      requestHeaderJson: { source: 501 }, // 需记录日志的请求接口的头部信息(token不存)
      ext1, // 行为描述
      ext2,
      ext3,
      ext4,
      ext5: (new Date()).toLocaleString()
    };
    studylogApi.post('logs', bodyParams);
  } catch (error) {

  }
};

// 获取微课地址
export const getWeikeAuthurl = params => kngApi.get('xuanke/authurl', {params});
// 获取微课原文的信息
export const getWeikeInfo = (id)=> kngApi.get(`xuanke/${id}/detail`);
// 当前目录及其父目录的code
export const getCatalogCode = (catalogId) => kngApi.get(`kngCatalog/catalog/code/${catalogId}`);
// 获取学分配置
export const getScoreConfig = () => kngApi.post('score/conf/info');
// 获取机构参
export const getOrgParameter = (code, orgId) => miscApi.get(`orgparsetting/code?code=${code}&orgId=${orgId}`);
